import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { ProofDocumentTypes } from '@app-model/proofs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
@Component({
    selector: 'app-media-dialog',
    templateUrl: `./file-dialog.component.html`,
    styleUrls: ['./file-dialog.component.scss'],
    standalone: false
})

export class FileDialogComponent {
  proofTypes = ProofDocumentTypes
  pdfSrc = null;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { mediaUrl: string, mediaType: "DOCUMENT" | "VIDEO" | "IMAGE", sanitizedPdfUrl?: SafeResourceUrl },
    private dialogRef: MatDialogRef<FileDialogComponent>,

  ) {
    if(data.mediaType === 'DOCUMENT') {
      this.pdfSrc = data.sanitizedPdfUrl;
    }
  
  }
  downloadFileFromUrl(pdfUrl: string) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.href = pdfUrl;

    a.target = '_blank'; 
    a.click();
    document.body.removeChild(a); 
  }


  closeDialog() {
    this.dialogRef.close();
  }
}